import React from "react";
import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import APP_MOVIL from "../../../assets/img/APP_MOVIL.jpg";
import APP_IONIC from "../../../assets/img/APP_IONIC.png";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import IndustryFooterButtonSection from "./../../Atoms/IndustryFooterButtonSection/IndustryFooterButtonSection";
import RegularIconText from "./../../Atoms/RegularIconText/RegularIconText";
import TIEMPO_REAL_ICON from "../../../assets/img/TIEMPO_REAL_ICON.svg";
import ANALISIS_PRECISO_ICON from "../../../assets/img/ANALISIS_PRECISO_ICON.svg";
import TODO_EN_UNO_ICON from "../../../assets/img/TODO_EN_UNO_ICON.svg";
import FACIL_DE_USAR_ICON from "../../../assets/img/FACIL_DE_USAR_ICON.svg";
import EFICIENCIA_ICON from "../../../assets/img/EFICIENCIA_ICON.svg";
import FLEXIBILIDAD_ICON from "../../../assets/img/FLEXIBILIDAD_ICON.svg";
import "./SolutionsAplicacionesMoviles.scss";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "./content.js";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const SolutionsAplicacionesMoviles = () => {
	const { language } = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

	return (
		<>
			<ChangeableHeaderV2
				withTitle
				appearSecondNavbar={dropdownHeader} 
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_yellow_span}
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].aplicaciones_yellow_title}
					boldText={content[language].aplicaciones_bold_title}
				/>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{
						img: APP_MOVIL,
						alt: "Tablet con Graficos en Pantalla",
					}}
					imgRadius
					boldText={content[language].aplicaciones_bold_text}
					paragraphs={content[language].aplicaciones_paragraphs}
				/>
			</div>

			<div className="light-blue-bg top-space-section bottom-space-section padding ">
				<CenteredHeader
					yellowText={content[language].ionic_develop_yellow_title}
					boldText={content[language].ionic_develop_bold_title}
				/>
				<div className="top-space-section no-top-space-responsive padding">
					<IndustryImageTextSection
						image={{ img: APP_IONIC, alt: "Mapa" }}
						boldText={content[language].ionic_develop_bold_text}
						paragraphs={content[language].ionic_develop_paragraphs}
						responsiveImgPosition="last"
					/>
				</div>
			</div>

			<div className="pb-140">
				<IndustryBannerBgSection route="aplicaciones-moviles" laptopImg>
					<div className="flex column space-around center-cross-axis">
						<h5 className="t5 center-text c-yellow yellow-line both-sides">
							{content[language].our_apps_yellow_title}
						</h5>
						<div className="max-width flex center-cross-axis space-around wrap">
							<div className="solutionsAplicacionesMoviles--regular_icon-container">
								<RegularIconText
									width="100%"
									whiteText
									icon={TIEMPO_REAL_ICON}
									boldText={content[language].app_1.boldText}
									text={content[language].app_1.text}
								/>
							</div>

							<div className="solutionsAplicacionesMoviles--regular_icon-container">
								<RegularIconText
									width="100%"
									whiteText
									icon={FLEXIBILIDAD_ICON}
									boldText={content[language].app_2.boldText}
									text={content[language].app_2.text}
								/>
							</div>

							<div className="solutionsAplicacionesMoviles--regular_icon-container">
								<RegularIconText
									width="100%"
									whiteText
									icon={EFICIENCIA_ICON}
									boldText={content[language].app_3.boldText}
									text={content[language].app_3.text}
								/>
							</div>

							<div className="solutionsAplicacionesMoviles--regular_icon-container">
								<RegularIconText
									width="100%"
									whiteText
									icon={ANALISIS_PRECISO_ICON}
									boldText={content[language].app_4.boldText}
									text={content[language].app_4.text}
								/>
							</div>

							<div className="solutionsAplicacionesMoviles--regular_icon-container">
								<RegularIconText
									width="100%"
									whiteText
									icon={FACIL_DE_USAR_ICON}
									boldText={content[language].app_5.boldText}
									text={content[language].app_5.text}
								/>
							</div>

							<div className="solutionsAplicacionesMoviles--regular_icon-container last">
								<RegularIconText
									width="100%"
									whiteText
									icon={TODO_EN_UNO_ICON}
									boldText={content[language].app_6.boldText}
									text={content[language].app_6.text}
								/>
							</div>
						</div>
					</div>
				</IndustryBannerBgSection>
			</div>

			<div className="top-space-section bottom-space-section">
				<CenteredHeader
					yellowText={content[language].develop_yellow_title}
					boldText={content[language].develop_bold_title}
				/>
			</div>

			<IndustryFooterButtonSection />
		</>
	);
};

export default SolutionsAplicacionesMoviles;
